import {Box} from '@primer/react'
import {graphql} from 'relay-runtime'
import {useFragment} from 'react-relay'
import {Suspense} from 'react'
import type {ItemIdentifier} from '@github-ui/issue-viewer/Types'

import {AddSubIssueButtonGroup} from './AddSubIssueButtonGroup'
import {SubIssuesListLoadingSkeleton} from './SubIssuesListLoadingSkeleton'
import {SubIssuesListView} from './SubIssuesListView'

import type {SubIssuesList$key} from './__generated__/SubIssuesList.graphql'

export function SubIssuesList({
  issueKey,
  onSubIssueClick,
}: {
  issueKey: SubIssuesList$key
  onSubIssueClick?: (itemIdentifier: ItemIdentifier, url: string) => void
}) {
  const subIssuesListData = useFragment(
    graphql`
      fragment SubIssuesList on Issue {
        ...SubIssuesListView
        ...AddSubIssueButtonGroup
      }
    `,
    issueKey,
  )

  return (
    <Box
      sx={{
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'border.default',
        borderRadius: 2,
        gap: 4,
      }}
    >
      <Suspense fallback={<SubIssuesListLoadingSkeleton />}>
        <SubIssuesListView onSubIssueClick={onSubIssueClick} issueKey={subIssuesListData} />
      </Suspense>
      <Box sx={{p: 2}}>
        <AddSubIssueButtonGroup issue={subIssuesListData} />
      </Box>
    </Box>
  )
}

try{ SubIssuesList.displayName ||= 'SubIssuesList' } catch {}